import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { User } from '@/lib/types';

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.users.profile(),
    queryFn: async (): Promise<User> => {
      const response = await apiClient.get<User>('/api/v1/profile/');
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}

export interface ProfileUpdatePayload {
  phone?: string;
  emergency_contact?: string;
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ProfileUpdatePayload): Promise<User> => {
      const response = await apiClient.patch<User>('/api/v1/profile/', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.users.profile() });
    },
  });
}
